_.namespace(module, function(require) {
  var ACPVisualGuidelinesDoc, DbHelper, Exceptions, MANUAL_REC_PREFIX, VisualGuidelinesRootDoc, Visualization, VisualizationUtils, W, ajax, alt, convertRowsToMap, createPrintoutContainer, delay, errorHandlerWithMsg, exportToFile, getAllGdtDataForOutcome, getChapterAndSectionIds, getContentPromise, getElementAppliedStylesString, getOrganizationName, hydratePopulationHeaderOrFooterContent, isAcpFeaturesOn, mediator, merge, removeHTMLNode, _ref, _ref1;
  ACPVisualGuidelinesDoc = require('lib/db_docs/acp_visual_guidelines_doc');
  Exceptions = require('lib/exceptions');
  _ref = require('lib/app_utils'), errorHandlerWithMsg = _ref.errorHandlerWithMsg, convertRowsToMap = _ref.convertRowsToMap, getOrganizationName = _ref.getOrganizationName;
  alt = require('alt');
  DbHelper = require('base/lib/db_helper');
  ajax = require('actions/async/api_helpers').ajax;
  mediator = require('mediator');
  isAcpFeaturesOn = require('stores/utils/etd_template_helper').isAcpFeaturesOn;
  merge = require('lodash').merge;
  MANUAL_REC_PREFIX = require('lib/etd_helper').MANUAL_REC_PREFIX;
  Visualization = VIComponents.Visualization;
  VisualizationUtils = require('lib/visualization_utils');
  VisualGuidelinesRootDoc = require('lib/db_docs/visual_guidelines_root_doc');
  W = require('when');
  delay = require('when/delay');
  exportToFile = require('lib/export_to_file').exportToFile;
  getChapterAndSectionIds = require('lib/mda_helper').getChapterAndSectionIds;
  getAllGdtDataForOutcome = require('lib/nma_helper').getAllGdtDataForOutcome;
  getContentPromise = require('lib/services/document_sections_exporter/utils').getContentPromise;
  _ref1 = require('base/lib/utils'), removeHTMLNode = _ref1.removeHTMLNode, createPrintoutContainer = _ref1.createPrintoutContainer, getElementAppliedStylesString = _ref1.getElementAppliedStylesString;
  hydratePopulationHeaderOrFooterContent = function(populationSection) {
    var populations, _ref2, _ref3;
    populations = (_ref2 = populationSection != null ? (_ref3 = populationSection.additionalData) != null ? _ref3.populations : void 0 : void 0) != null ? _ref2 : {};
    return W.all(_.flatten(_.map(populations, function(population, populationId) {
      return _.compact([
        population.header != null ? getContentPromise("" + populationId + "_header", population.header).then(function(htmlContent) {
          return population.header = htmlContent || '';
        }) : void 0, population.footer != null ? getContentPromise("" + populationId + "_footer", population.footer).then(function(htmlContent) {
          return population.footer = htmlContent || '';
        }) : void 0
      ]);
    }))).then(function() {
      return populationSection;
    });
  };
  return {
    gatherData: function(itemId) {
      var adapter, exportService, exportedVIId, organizationName, projectId, tableData, visualizationRootId;
      adapter = mediator.services.storePersistenceAdapter;
      exportService = mediator.services.documentSectionsExportService;
      projectId = mediator.project.id;
      visualizationRootId = alt.stores.ACPVisualGuidelinesStore.getCurrentVisualizationRootId();
      tableData = alt.stores.ACPVisualGuidelinesStore.getInteractiveTableData();
      exportedVIId = "" + projectId + "-" + itemId;
      organizationName = getOrganizationName();
      return W.all([ACPVisualGuidelinesDoc.at(projectId, itemId).fetch(), VisualGuidelinesRootDoc.at(projectId, visualizationRootId).fetch()]).then(function(_arg) {
        var mainDoc, rootDoc;
        mainDoc = _arg[0], rootDoc = _arg[1];
        return getChapterAndSectionIds(projectId, rootDoc).then(function(chaptersAndSectionIds) {
          return W.all([adapter.fetch(mediator.project.id, chaptersAndSectionIds.chapterIds), adapter.fetch(mediator.project.id, chaptersAndSectionIds.sectionIds)]);
        }).then(function(_arg1) {
          var chapterDocs, chapters, chaptersToSlugMap, sectionDocs, sections;
          chapters = _arg1[0], sections = _arg1[1];
          sectionDocs = convertRowsToMap(sections.rows || []);
          chapterDocs = convertRowsToMap(chapters.rows || []);
          chaptersToSlugMap = exportService.convertChaptersToSlugMap(chapterDocs.toJS());
          return exportService.processChaptersAndSections(chapterDocs.toJS(), sectionDocs.toJS(), rootDoc.chaptersOrder, {
            exportDate: new Date().toISOString(),
            guidelineId: exportedVIId,
            chaptersToSlugMap: chaptersToSlugMap
          }).then(function(_arg2) {
            var fullReferencesData, processedChapters, processedSections, processedSectionsObjs, referencesIds, _ref2;
            processedChapters = _arg2[0], processedSectionsObjs = _arg2[1];
            _ref2 = exportService.processSectionObjs(processedSectionsObjs), processedSections = _ref2.processedSections, referencesIds = _ref2.referencesIds, fullReferencesData = _ref2.fullReferencesData;
            return {
              processedSections: merge(_.indexBy(processedSections, 'guid'), sectionDocs.toJS()),
              referencesIds: referencesIds,
              fullReferencesData: fullReferencesData,
              processedChapters: _.indexBy(processedChapters, 'guid')
            };
          });
        }).then(function(_arg1) {
          var fullReferencesData, populationSection, processedChapters, processedSections, referencesIds;
          processedChapters = _arg1.processedChapters, processedSections = _arg1.processedSections, referencesIds = _arg1.referencesIds, fullReferencesData = _arg1.fullReferencesData;
          populationSection = _.find(processedSections, function(section) {
            return section.sectionType === 'acp_recommendations_populations';
          });
          return hydratePopulationHeaderOrFooterContent(populationSection).then(function(populationSection) {
            var allReferencesIds, recommendationIds, recommendations, references;
            recommendationIds = _.chain(populationSection.additionalData.populations).pluck('recommendations').flatten().compact().filter(function(recId) {
              return recId.indexOf(MANUAL_REC_PREFIX) === -1;
            }).map(function(recId) {
              return recId.split('_')[0];
            }).uniq().value();
            allReferencesIds = _.uniq(referencesIds);
            references = exportService.processReferences(allReferencesIds, fullReferencesData);
            recommendations = alt.stores.EtdsStore.getRecommendations(recommendationIds);
            return VisualizationUtils.getVisualizationData(tableData, Immutable.fromJS(populationSection), recommendations).then(function(_arg2) {
              var analysis, analysisGroups, outcomes, recommendations, viDoc;
              analysisGroups = _arg2.analysisGroups, recommendations = _arg2.recommendations, outcomes = _arg2.outcomes;
              analysis = analysisGroups.map(function(analysisGroupId) {
                var nma;
                nma = alt.stores.NMAListStore.getQuestion(analysisGroupId);
                return {
                  _id: nma.get('_id'),
                  title: nma.get('question'),
                  interventions: nma.get('interventions', Immutable.List()).toJS(),
                  outcomes: _.compact(nma.get('outcomes').map(function(outcomeId) {
                    var tmpOutcome;
                    tmpOutcome = outcomes[outcomeId];
                    if (!tmpOutcome) {
                      return;
                    }
                    tmpOutcome.data = getAllGdtDataForOutcome(tmpOutcome);
                    return tmpOutcome;
                  }).toJS())
                };
              });
              viDoc = {
                organizationName: organizationName,
                settings: mainDoc.settings,
                visualization: _.omit(mainDoc, 'settings'),
                visualizationRootDoc: rootDoc,
                chapters: processedChapters,
                sections: processedSections,
                references: references.toJS(),
                recommendations: recommendations,
                analysis: analysis
              };
              return {
                exportedVIId: exportedVIId,
                viDoc: viDoc
              };
            });
          });
        });
      });
    },
    exportVi: function(itemId) {
      var adapter, organizationName, projectId;
      adapter = mediator.services.storePersistenceAdapter;
      projectId = mediator.project.id;
      organizationName = getOrganizationName();
      return this.gatherData(itemId).then(function(_arg) {
        var exportedVIId, viDoc;
        exportedVIId = _arg.exportedVIId, viDoc = _arg.viDoc;
        return adapter.updateOrCreate(DbHelper.getVIGuidelinesDbUrl(), exportedVIId, function(doc) {
          return _.extend({}, doc, {
            organizationName: organizationName,
            currentVersion: (doc.currentVersion || 0) + 1,
            _id: exportedVIId
          });
        }).then(function(res) {
          var newId;
          newId = "" + exportedVIId + "-" + res.currentVersion;
          return ajax({
            url: "" + (DbHelper.getBackendUrl()) + "/frozen-presentations/vi_guidelines/" + projectId + "/" + newId,
            method: "PUT",
            xhrFields: {
              withCredentials: true
            },
            data: JSON.stringify(_.extend({}, viDoc, {
              organizationName: organizationName
            }))
          });
        });
      })["catch"](function(err) {
        return errorHandlerWithMsg(err, $.t('vi:export_error'));
      });
    },
    getEmbeddableHTML: function(viUrl) {
      var attrsString;
      attrsString = 'frameborder=\"0\" width=\"100%\" height=\"100%\" allowfullscreen';
      return "<iframe src=\"" + viUrl + "\" " + attrsString + "></iframe>";
    },
    exportVIGuidelines: function(itemId) {
      return this.exportVi(itemId).then(function(_arg) {
        var newTab, url;
        url = _arg.url;
        newTab = window.open('about:blank', '_blank');
        if (newTab) {
          return newTab.location.href = url;
        } else {
          throw new Exceptions.visual_guidelines_export_failed(url);
        }
      });
    },
    exportVIGuidelinesToPdf: function(itemId) {
      return this.gatherData(itemId).then(function(_arg) {
        var $charsetEl, $copyrightEl, $metaEl, $styleEl, $visualization, VisualizationPreview, additionalData, date, exportedVIId, fakeDoc, generalInformationsSection, sections, tempContainer, viDoc, visualizationDocHTML, _ref2, _ref3;
        exportedVIId = _arg.exportedVIId, viDoc = _arg.viDoc;
        tempContainer = createPrintoutContainer();
        VisualizationPreview = React.createElement(Visualization, {
          i18n: i18next,
          data: viDoc,
          config: {
            organizationName: getOrganizationName(),
            printout: true
          }
        });
        ReactDOM.render(VisualizationPreview, tempContainer);
        $visualization = tempContainer.querySelector('#visual-guidelines-container');
        if ((_ref2 = $visualization.querySelector('.interactive-visualization')) != null) {
          _ref2.remove();
        }
        if ((_ref3 = $visualization.querySelector('.project-info-banner')) != null) {
          _ref3.remove();
        }
        sections = viDoc.sections;
        generalInformationsSection = _.find(sections, function(section) {
          return section.sectionType === "acp_visual_guideline_general_information_form";
        });
        additionalData = (generalInformationsSection || {}).additionalData;
        date = new Date(additionalData != null ? additionalData.publicationDate : void 0).getFullYear() || new Date().getFullYear();
        $copyrightEl = document.createElement('div');
        $copyrightEl.innerHTML = isAcpFeaturesOn() ? "&copy; " + date + " American College of Physicians" : "&copy; " + date + " GRADEpro";
        $copyrightEl.style.textAlign = 'right';
        $visualization.appendChild($copyrightEl);
        fakeDoc = document.implementation.createHTMLDocument('');
        $metaEl = document.createElement('meta');
        $metaEl.setAttribute('name', 'viewport');
        $metaEl.setAttribute('content', 'width=device-width, initial-scale=1');
        $charsetEl = document.createElement('meta');
        $charsetEl.setAttribute('charset', 'utf-8');
        $styleEl = document.createElement('style');
        $styleEl.innerHTML = getElementAppliedStylesString($visualization);
        fakeDoc.head.appendChild($metaEl);
        fakeDoc.head.appendChild($styleEl);
        fakeDoc.head.appendChild($charsetEl);
        fakeDoc.body.innerHTML = $visualization.outerHTML;
        visualizationDocHTML = '<!doctype html>' + fakeDoc.documentElement.outerHTML;
        fakeDoc = null;
        removeHTMLNode(tempContainer);
        return exportToFile('pdf', visualizationDocHTML, {
          fileName: "" + (mediator.project.get('name').slice(0, 255)),
          orientation: 'portrait',
          margins: {
            top: 2.7,
            right: 2.7,
            bottom: 2.7,
            left: 2.7
          }
        });
      })["catch"](function(err) {
        return errorHandlerWithMsg(err, $.t('vi:export_error'));
      });
    }
  };
});
